module.exports = __webpack_public_path__ + "static/media/img_packshot_all.da9bd9f9.png";